import React from 'react';
import {
    Col, Row, Table, Modal, Grid, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import _ from 'lodash';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import { API_ROOT } from '../../../variables/api-config';
import './ContractEditor.css';
import ModalBlockWrapper from '../../Components/ModalBlockWrapper';

class ContratoTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      archivo: null,
      ventas: null,
      acciones: null,
      vencimiento: null,
      canon: null,
      contentState: null,
      nombre: null,
      idcontrato: null,
      defaultContentState: null,
      nombrearchivo: null,
      errorNombre: false,
      errorVencimiento: false,
    };

    this.generateTable = this.generateTable.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.saveContrato = this.saveContrato.bind(this);
    this.onContentStateChange = this.onContentStateChange.bind(this);
    this.editContract = this.editContract.bind(this);
  }

  onContentStateChange(contentState) {
    this.setState({
      contentState,
    });
  };

  generateTable() {
    const html = [];
    this.props.usersContracts.forEach((item, index) => {
      const firmas = [];
      item.usuarios.forEach((user, i) => {
        firmas.push(
          <tr key={'user'+i}>
            <td>{user.username}</td>
            <td style={{textAlign:'center'}}>
              { parseInt(user.firmado, 10) ?
                <i style={{color: '#2ee41f'}} className="fa fa-check"></i> :
                <i style={{color: '#e40040'}} className="fa fa-times"></i>
              }
            </td>
          </tr>
        );
      })
      html.push(
        <tr key={index}>
          <td>{item.contrato.nombre}</td>
          <td>
            <Table responsive>
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th style={{textAlign:'center'}}>Firmado</th>
                </tr>
              </thead>
              <tbody>
                {firmas}
              </tbody>
            </Table>
          </td>
          <td style={{textAlign: 'right'}}>
            <Button simple bsStyle="warning" bsSize="xs" onClick={() => this.editContract(item.contrato.id)}>
                <i className="fa fa-edit"></i>
            </Button>
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/incubation/contract/download/file?id=${item.contrato.id}`}>
                <i className="fa fa-file"></i>
              </a>
            </Button>
          </td>
        </tr>
      );
    });
    return html;
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ archivo: this.uploadInput.files[0], nombrearchivo: this.uploadInput.files[0].name });
  }

  editContract(id) {
    this.props.incubationService
      .getContractById(id)
      .then(res => {
        this.setState({
          ventas: res.contrato.ventas,
          acciones: res.contrato.acciones,
          vencimiento: res.contrato.vencimiento,
          canon: res.contrato.canon,
          defaultContentState: (JSON.parse(res.contrato.contrato)),
          contentState: (JSON.parse(res.contrato.contrato)),
          nombre: res.contrato.nombre,
          nombrearchivo: res.contrato.originalname,
          idcontrato: res.contrato.id,
          showModal: true,
        });
      })
      .catch(err => {
        this.props.setError(
          <div>
            Ha ocurrido un error mientras se cargaba el contrato, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  saveContrato() {
    const contrato = {
      archivo: this.state.archivo,
      vencimiento: this.state.vencimiento,
      acciones: this.state.acciones,
      ventas: this.state.ventas,
      canon: this.state.canon,
      nombre: this.state.nombre,
      contrato: JSON.stringify(this.state.contentState),
      idproyectoincubacion: this.props.projectId,
      id: this.state.idcontrato,
    };
    console.log(contrato);
    let error = false;
    if (!contrato.nombre || contrato.nombre === '') {
      error = true;
      this.setState({ errorNombre: true });
    }
    if (!contrato.vencimiento || contrato.vencimiento === '') {
      error = true;
      this.setState({ errorVencimiento: true });
    }

    if (error) {
      this.props.setError(
        <div>
          Uno o mas campos contienen errores o no han sido completados!
        </div>
      );
    } else {
      this.props.incubationService
      .postContrato(contrato)
      .then(res => {
        this.props.showAlert(
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Guardado!"
            onConfirm={() => this.props.hideAlert()}
            onCancel={() => this.props.hideAlert()}
            confirmBtnBsStyle="info"
            confirmBtnText="Aceptar"
          >
            El contrato ha sido guardado satisfactoriamente
          </SweetAlert>
          );
          this.props.refreshContracts();
          this.closeModal();
        })
        .catch(err => {
          this.props.setError(
            <div>
              Ha ocurrido un error mientras se cargaba el contrato, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>
          );
        });
    }
  }

  closeModal() {
    this.setState({
      archivo: null,
      ventas: null,
      acciones: null,
      vencimiento: null,
      canon: null,
      contentState: null,
      nombre: null,
      idcontrato: null,
      defaultContentState: null,
      showModal: null,
      nombrearchivo: null,
    });
  }

  render() {
    if (!this.props.usersContracts) {
      return (<div></div>);
    }
    return (
      <div>
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <div
                style={{ paddingBottom: 10 + "px", textAlign: "right" }}
              >
                <Button
                  bsStyle="primary"
                  bsSize="sm"
                  fill
                  wd
                  onClick={() => this.setState({showModal: true})}
                >
                  Cargar Contrato
                </Button>
              </div>
              {_.isEmpty(this.props.usersContracts) ?
                <div>No hay contratos</div> :
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Contrato</th>
                      <th style={{textAlign: 'center'}}>Firmas</th>
                      <th style={{textAlign: 'right'}}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.generateTable()}
                  </tbody>
                </Table>
              }
            </Col>
          </Row>
        </Grid>
        <Modal show={this.state.showModal} onHide={() => this.closeModal()} style={{ display: "block" }} bsSize="large">
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>Cargar Contrato</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md={12}>
                      <Form horizontal>
                        <FormGroup validationState={this.state.errorNombre ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                            Nombre del Contrato:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="text" value={this.state.nombre ? this.state.nombre : ''}
                              onChange={(e) => this.setState({ nombre: e.target.value, errorNombre: false })}
                            />
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div style={{height: 300, borderWidth: 1, borderStyle: 'inset'}}>
                        <Editor
                          wrapperClassName="editor-height"
                          onContentStateChange={this.onContentStateChange}
                          localization={{ locale: 'es' }}
                          contentState={this.state.defaultContentState}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{paddingTop: 10}}>
                    <Col md={7}>
                      <FormGroup>
                        <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                          Archivo:
                        </Col>
                        <Col md={9}>
                          <FormControl
                            type="text" value={this.state.nombrearchivo ? this.state.nombrearchivo : 'No hay archivo'}
                            disabled
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col md={5}>
                      <span style={{ float: 'right' }}>
                        <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                        <Button disabled={!this.state.archivo && !this.state.nombrearchivo} onClick={() => this.setState({ archivo: null, nombrearchivo: null })} bsStyle="danger" fill={true}>
                          <i className="fa fa-ban"></i>
                        </Button>
                      </span>
                      <span style={{ float: 'left' }}>
                        <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <h6>Condiciones Variables</h6><br/>
                      <Form horizontal={true}>
                        <FormGroup validationState={this.state.errorVencimiento ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                            Vencimiento:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="date" value={this.state.vencimiento ? this.state.vencimiento : ''}
                              onChange={(e) => this.setState({ vencimiento: e.target.value, errorVencimiento: false })}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                            % Ventas:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.ventas ? this.state.ventas : ''}
                              onChange={(e) => this.setState({ ventas: e.target.value })}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                            % Accionario:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.acciones ? this.state.acciones : ''}
                              onChange={(e) => this.setState({ acciones: e.target.value })}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                            Canon mensual:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.canon ? this.state.canon : ''}
                              onChange={(e) => this.setState({ canon: e.target.value })}
                            />
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button simple onClick={this.closeModal}>
                    Cancelar
                  </Button>
                  <Button
                    bsStyle="success" fill onClick={this.saveContrato}
                  >
                    Guardar
                  </Button>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>
      </div>
    );
  }
}

export default ContratoTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/IncubationPage/ContratoTab.jsx